import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import SignUpMain from "./SignUpMain";

const SignUp = () => (
  <>
    <Header />
    <SignUpMain />
    <Footer />
  </>
);

export default SignUp;
